import { useNavigate } from 'react-router-dom'
import type { Party } from '@/types'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { IdeologyMini } from '@/components/ideology/IdeologyDisplay'
import { PoliticalBadge } from '@/components/ideology/PoliticalLabel'

interface PartyCardProps {
  party: Party
  isUserParty?: boolean
}

export function PartyCard({ party, isUserParty = false }: PartyCardProps) {
  const navigate = useNavigate()

  return (
    <Card
      className="cursor-pointer transition-shadow hover:shadow-md"
      onClick={() => navigate(`/parties/${party.id}`)}
    >
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            <div
              className="h-4 w-4 rounded-full"
              style={{ backgroundColor: party.color }}
            />
            <CardTitle className="text-base">
              {party.name} ({party.abbreviation})
            </CardTitle>
          </div>
          {isUserParty && <Badge variant="secondary">Your Party</Badge>}
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 text-sm">
          {party.slogan && (
            <p className="text-muted-foreground italic">"{party.slogan}"</p>
          )}
          {/* Public info: ideology indicator */}
          <div className="flex items-center gap-2 text-muted-foreground">
            <span className="text-xs">Ideology:</span>
            <IdeologyMini ideology={party.ideology_vector} />
          </div>
          {/* Political position badge */}
          <div className="pt-1">
            <PoliticalBadge ideology={party.ideology_vector} />
          </div>
          {/* Private info: only show to party owner */}
          {isUserParty && (
            <div className="flex gap-4 text-muted-foreground text-xs pt-1 border-t">
              <span>AP: {party.action_points}</span>
              <span>Prestige: {party.prestige}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
